import React from 'react';
import {observer} from 'mobx-react';
import {StandingsWidgetTableFormCell} from "./standings-widget.table-form-cell";
import {ScrollableTableTextCell} from "../../../../core/components/scrollable-table/scrollable-table-text-cell";
import {StandingsWidgetTableNextMatchCell} from "./standings-widget.table.next-match.cell";

export const StandingsWidgetTableCell = observer(({controller, index, competitor, cell, hasBorder}) => {
  const baseProps = {
    cell
  }

  const recentFormProps = {
    controller,
    competitor,
    hasBorder,
    ...baseProps
  }

  const nextMatchProps = {
    controller,
    competitor,
    ...baseProps
  }

  const textCellProps = {
    hasBorder,
    ...baseProps
  }

  let CellComponent = <ScrollableTableTextCell {...textCellProps} key={index}/>;

  if (cell.isRecentForm) {
    CellComponent = <StandingsWidgetTableFormCell {...recentFormProps} key={index}/>
  } else if (cell.isNextMatch) {
    CellComponent = <StandingsWidgetTableNextMatchCell {...nextMatchProps} key={index}/>
  }

  return CellComponent;
});
